import { css } from '@/styled-system/css';

export const conversationItemStyles = css.raw({
  display: 'flex',
  alignItems: 'flex-start',
  width: '100%',
  padding: 'default',
  borderLeft: '4px solid transparent',
  textAlign: 'left',
  cursor: 'pointer',
  backgroundColor: 'bg.neutral',

  _hover: {
    backgroundColor: 'bg.action.neutral.hover',
  },
});

export const conversationItemActivateStyles = css.raw({
  display: 'block',
  width: '100%',
  textAlign: 'left',

  _focusVisible: {
    // Any parent with overflow: auto (e.g. ConversationList) will clip the box shadow focus styles
    // So, we use a combination of outline and box shadow to achieve a similar effect
    outlineWidth: '2px',
    outlineOffset: '-2px',
    outlineStyle: 'solid',
    outlineColor: 'border.action.hero.default',
    boxShadow: 'var(--shadows-focus)',
    position: 'relative',
    zIndex: 1,
  },
});

export const listItemStyles = css.raw({
  paddingInline: 0,
  paddingBlock: 0,
  listStyle: 'none',
  width: '100%',
});

export const messageContentWrapperStyles = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 'tight',
  gap: 'tightest',
});
